import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { MpItemCop } from 'models/mp/MpItemCop';

/**
 * 법인 대상 등록 여부 확인
 * @param itemId
 */
export const existMpItemCop = async (itemId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/${itemId}/exist-cop`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<boolean> = await callApi(request);
  return response;
};

/**
 * 법인 대상 목록 조회
 * @param condition
 */
export const findMpItemCop = async (itemId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/${itemId}/cop`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<MpItemCop[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : []) as MpItemCop[];
};

/**
 * 대상 법인별 공장/수평전개담당자 수 조회
 * @param itemId
 * @param mpPrdnPlntId
 */
export const findPlantHorExplCrgeUserCount = async (itemId: string, mpPrdnPlntId?: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/${itemId}/plant-count`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ mpPrdnPlntId: mpPrdnPlntId || '' }),
  };

  const response: CommonResponse<MpItemCop[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : []) as MpItemCop[];
};

/**
 * 법인 대상 설정 저장
 * @param itemId
 */
export const saveMpItemCop = async (itemId: string, copList: MpItemCop[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/${itemId}/cop`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: copList,
  };

  const response: CommonResponse = await callApi(request);
  return response;
};
